/**
 *
 * WARNING: We're only using react-redux-hotline in Student page only.
 *
 */

import { install } from 'vendor/react-redux-hotline';
import unarchiveStudentCtrl from "controllers/student/unarchiveStudent"
import getStudentSummary from "controllers/student/getStudentSummary";
import archiveStudent from './archive-student';
import { DEFAULT_PAGINATION } from './constants'
import alert from 'util/alert';

const initState = {
  studentList: [],
  studentSelectedByCheckbox: [],
  touchedServer: false,
  count: 0,
  pagination: DEFAULT_PAGINATION,
}

const methods = {
  setStudentState: ({setState, state, methods}, newState) => {
    setState({
      studentState: newState,
    });
  },

  fetchStudent: ({setState, state, methods}, studentState, pagination = {}, searchKeyword, order_by) => {
    if (typeof studentState !== 'string') throw new Error('studentState must be a string.');

    const schoolId = localStorage.getItem("schoolId");

    setState({
      fetching: true,
      counted: false,
      studentState,
      searchStudentKeyword: searchKeyword
    });

    const itemsCountPerPage = pagination.itemsCountPerPage || state.pagination.itemsCountPerPage;

    const activePage = pagination.activePage || state.pagination.activePage;

    getStudentSummary({
			schoolId,
      itemPerPage: itemsCountPerPage,
      pageNumber: activePage,
			studentState: studentState || state.studentState,
      searchKeyword: searchKeyword,
      order_by,
    })
    .then((res)=>{

      let params = {
        fetching: false,
        studentList: res.list,
        pagination: {
          activePage,
          itemsCountPerPage,
          totalItemsCount: res.student_count,
        },
        currentCount: res.student_count,
        school_has_student: res.school_has_student

      }

      setState(params);

    })
    .catch((err) => {

      let params = {
        fetching: false,
      }

      setState(params);

    })

  },

  unarchiveStudent: ({setState, state, methods}, studentID) => {

    unarchiveStudentCtrl(studentID)
      .then((res)=>{
        if(res.data.result === 'failure'){
          alert.message(__('You are about go over the student limit, please upgrade to higher subscription plan to add more students', 'header'), __('Upgrade Subscription Plan', 'header'))
        }else{
          
          methods.student.fetchStudent('after student is unarchived @unarchiveStudent', 'archived');
        }
        // ... for now it's empty
      })
      .catch((err)=>{
        // ... for now it's empty
      });

  },

  updateSelectedStudents: ({setState, state, methods}, studentSelectedByCheckbox) => {
    setState({
      studentSelectedByCheckbox,
    });
  },

  archiveSingleStudent: ({setState, state, methods}, student)=>{
    archiveStudent([student], ()=>{
      methods.student.fetchStudent('after archived a single student', state.studentState);
    });
  },

  archiveMultipleSelectedStudents: ({setState, state, methods})=>{

    const students = state.studentSelectedByCheckbox;

    archiveStudent(students, (res)=>{

      methods.student.fetchStudent('after archived multiple students', state.studentState);

    });

  },
}

install('student', initState, methods);



// WEBPACK FOOTER //
// ./src/containers/pages/Student/hotline.js